import { Skeleton } from '@/shared/ui';

export function ComparisonSidePanelSkeleton() {
  return (
    <div className="fixed top-16 right-0 z-40 h-full w-1/2">
      <aside className="absolute right-0 h-[calc(100%-64px)] w-full bg-neutral-950 p-4">
        <Skeleton className="mb-4 h-8 w-48" />
        <Skeleton className="mb-2 h-4 w-full" />
        <Skeleton className="mb-2 h-4 w-full" />
        <Skeleton className="h-4 w-3/4" />
      </aside>
    </div>
  );
}
